export interface TableDefinitions {
	requestingClass: string;	// Class Request 
	definedTables: string[];    // Tables' Id.
}

export const TABLE_DEFINERS: TableDefinitions[] =
[
	{ requestingClass: 'UploadFileComponent'			, definedTables: ['tab_info', 'job_info'] },
	{ requestingClass: 'WatchComponent'					, definedTables: ['tab_journal_watch', 'tab_notifi'] },
	{ requestingClass: 'MaintainAccountComponent'		, definedTables: ['tab_maint_acc'] },
	{ requestingClass: 'TabAdditionalNameComponent'		, definedTables: ['tab_addi_name'] },
	{ requestingClass: 'TabAddressesComponent'			, definedTables: ['tab_addr'] },
	{ requestingClass: 'TabEmailsComponent'				, definedTables: ['tab_email'] },
	{ requestingClass: 'TabMoveCode6111Component'		, definedTables: ['tab_mc_6111'] },
	{ requestingClass: 'TabMoveCodesComponent'			, definedTables: ['tab_mc'] },
	{ requestingClass: 'TabPaymentInfoComponent'		, definedTables: ['tab_pay_info'] },
	{ requestingClass: 'TabPhoneNumbersComponent'		, definedTables: ['tab_phone_num'] },
	{ requestingClass: 'TabProfilersComponent'			, definedTables: ['tab_profile'] },
	{ requestingClass: 'TabRelationsComponent'			, definedTables: ['tab_rels'] },
	{ requestingClass: 'TabUploadsComponent'			, definedTables: ['tab_uploads'] },
	{ requestingClass: 'TabUrlsComponent'				, definedTables: ['tab_urls'] },
	{ requestingClass: 'DocApprovalComponent'			, definedTables: ['tab_doc_watch'] },
	{ requestingClass: 'WorkersInfoComponent'			, definedTables: ['tab_worker_info', 'tab_worker_asg', 'tab_worker_phu', 'tab_worker_emu'] },
	{ requestingClass: 'MoveinHistoryComponent'			, definedTables: ['tab_mov_main', 'tab_mov_data'] },
];
